import { gql } from '@apollo/client';

export default {
  subscription: {
    name: 'subscription',
    serviceName: 'graphql',
    query: gql`
      mutation subscription($cellphone: String, $token: String!, $zone: String) {
        subscription(cellphone: $cellphone, token: $token, zone: $zone) {
          messages
        }
      }
    `,
  },
  notes: {
    name: 'userNote',
    serviceName: 'auth',
    query: gql`
      query userNote($ids: [String]) {
        userNote(ids: $ids) {
          data {
            id
            shop {
              id
              title
            }
            zone
            type
            status
            content
            details
            send_type
            viewed_on
            is_archived
          }
        }
      }
    `,
  },
};
